export const trimIfTooLong = (
    str: string,
    maxLen = 20,
    splitChar = ' ',
    preserveLastWord = true
) => {
    let splittedChar = ''

    if (preserveLastWord) {
        str.split(splitChar).forEach((substring) => {
            if (splittedChar.length < maxLen) {
                splittedChar += `${substring} `
            }
        })
    } else {
        splittedChar = str.length > maxLen ? str.substring(0, maxLen) : str
    }

    if (str.length > splittedChar.length) {
        splittedChar = splittedChar.trim() + '…'
    }

    return splittedChar
}

export const getInitialsLetters = (name: string) => {
    const splitName = name.split(' ')
    if (splitName.length > 1) {
        const [name, surname] = splitName

        return `${name[0]}${surname[0]}`
    }

    return name.slice(0, 2)
}
